import React from 'react'
import utils from './utils'
import { images } from '../../../../services/assets.services'

function getLevelLayout(width, height, settings, quantities, answer) {
    return settings.operation === 'addition' ?
        getAdditionLayout(width, height, settings, quantities, answer) :
        getSubtractionLayout(width, height, settings, quantities, answer)
}

function getAdditionLayout(width, height, settings, quantities, answer) {
    let gameContainerWidth = width
    let gameContainerHeight = height
    let scale = 0
    let gridBgWidth = 377
    let gridBgHeight = 210
    let lineWidth = 377
    let lineHeight = 20
    let valueBgWidth = 43
    let valueBgHeight = 33
    let axisLineWidth = 12
    let axisLineHeight = 34
    let axisSideMargin = 12

    if (gridBgWidth / gridBgHeight > gameContainerWidth / gameContainerHeight) {
        scale = gameContainerWidth / gridBgWidth
    } else {
        scale = gameContainerHeight / gridBgHeight
    }

    const value_1 = quantities.value_1
    const value_2 = quantities.value_2
    const values = getValues(value_1, value_2, answer, settings)
    const operation = settings.operation

    const axisScale = +settings.axis_scale || 1

    let axisValues = []

    const roundOption = settings.step_size
    const step = getStepSize(value_2, roundOption)
    const type = +value_1 + step < +value_1 + +value_2 ? 'straight' : 'inverse'

    const axisStart = value_1
    const axisEnd = type === 'straight' ? value_1 + value_2 : +value_1 + step
    const axisDivWidth = (gridBgWidth - axisSideMargin * 2 - axisLineWidth) / (axisEnd - axisStart)

    const answerRequired = settings.answer_required || 'answer'
    
    let maxArcHeight = gridBgHeight

    for (let i = 0; i <= (axisEnd - axisStart); i += axisScale) {
        axisValues.push(
            
            <g transform={`translate(${axisSideMargin + i * axisDivWidth}, ${gridBgHeight - 20})`}>
                <image
                    width={axisLineWidth}
                    height={axisLineHeight}
                    xlinkHref={images.svg['number-line-axis']}
                    
                />
                <text
                    fill="#fff"
                    fontSize={12}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={6}
                    y={axisLineHeight + 10}
                    textAnchor="middle"
                >{+axisStart + i}</text>
            </g>
        )
    }

    let arcStart = axisSideMargin + axisLineWidth / 2 + (value_1 - axisStart) * axisDivWidth
    let arcLength = step * axisDivWidth
    let arcRadius = (arcLength) / 1.8
    let centerToChordLenght = Math.sqrt(Math.pow(arcRadius, 2) - Math.pow(arcLength / 2, 2))

    let arc2Start = axisSideMargin + axisLineWidth / 2 + (type === 'straight' ? +value_1 + +step - axisStart : +value_1 + +value_2 - axisStart) * axisDivWidth
    let arc2Length = (type === 'straight' ?  value_2 - step : step - value_2) * axisDivWidth
    let arc2Radius = (arc2Length) / 1.8
    let centerToChordLenght2 = Math.sqrt(Math.pow(arc2Radius, 2) - Math.pow(arc2Length / 2, 2))

    maxArcHeight = arcRadius > arc2Radius ? arcRadius - centerToChordLenght + 40 : arc2Radius - centerToChordLenght2 + 40
 
    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}

        >
            <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale - (gridBgHeight - maxArcHeight)* scale) / 2}), scale(${scale})`}>
                {axisValues}
                <image
                    width={lineWidth}
                    height={lineHeight}
                    xlinkHref={images.svg['number-line']}
                    transform={`translate(${0}, ${gridBgHeight - 13})`}
                />
                <g>
                    <path
                        d={`M${arcStart} 185 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#000"
                        strokeOpacity="0.1"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    <path
                        d={`M${arcStart} 180 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#95c11f"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    {utils.getArrowLayout(arcStart + arcLength, 185, 40, 4.01490021, "#95c11f")}
                     <g transform={`translate(${arcStart + arcLength / 2 - valueBgWidth / 2}, ${180 + centerToChordLenght - arcRadius - valueBgHeight * 1.2 })`}>
                        <image
                            width={valueBgWidth}
                            height={valueBgHeight}
                            xlinkHref={images.svg['number-line-bg-green']}
                            
                        />
                        <text
                            fill="#fff"
                            fontSize={12}
                            fontWeight="regular"
                            dominantBaseline="middle"
                            x={valueBgWidth / 2}
                            y={15}
                            textAnchor="middle"
                        >{answerRequired === 'step_1' ? answer : '+' + step}</text>
                    </g>
                </g>

                {+value_1 + +step != +value_1 + value_2 && <g>
                    <path
                        d={`M${arc2Start} 185 a ${arc2Radius} ${arc2Radius} 0 0 1 ${arc2Length} 0`}
                        stroke="#000"
                        strokeOpacity="0.1"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    <path
                        d={`M${arc2Start} 180 a ${arc2Radius} ${arc2Radius} 0 0 1 ${arc2Length} 0`}
                        stroke={type === 'straight' ? "#95c11f" : "#E30613"}
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />

                    {utils.getArrowLayout((type === 'straight' ? arc2Start + arc2Length : arc2Start), 185, 40, 4.01490021, (type === 'straight' ? "#95c11f" : "#E30613"))}

                    <g transform={`translate(${arc2Start + arc2Length / 2 - valueBgWidth / 2}, ${180 + centerToChordLenght2 - arc2Radius - (type === 'straight' || arc2Length < valueBgWidth ? valueBgHeight * 1.2 : -valueBgHeight * .2)})`}>
                        <image
                            width={valueBgWidth}
                            height={valueBgHeight}
                            xlinkHref={images.svg[`number-line-bg-${type === 'straight' ? 'green' : 'red'}`]}
                            
                        />
                        <text
                            fill="#fff"
                            fontSize={12}
                            fontWeight="regular"
                            dominantBaseline="middle"
                            x={valueBgWidth / 2}
                            y={15}
                            textAnchor="middle"
                        >{(answerRequired === 'step_2' ? answer : (type === 'straight' ?  '+' + (value_2 - step) : '-' + (step - value_2)))}</text>
                    </g>
                </g>}
            </g>
        </svg>
    )
}

function getSubtractionLayout(width, height, settings, quantities, answer) {
    let gameContainerWidth = width
    let gameContainerHeight = height
    let scale = 0
    let gridBgWidth = 377
    let gridBgHeight = 210
    let lineWidth = 377
    let lineHeight = 20
    let valueBgWidth = 43
    let valueBgHeight = 33
    let axisLineWidth = 12
    let axisLineHeight = 34
    let axisSideMargin = 12

    if (gridBgWidth / gridBgHeight > gameContainerWidth / gameContainerHeight) {
        scale = gameContainerWidth / gridBgWidth
    } else {
        scale = gameContainerHeight / gridBgHeight
    }

    const value_1 = quantities.value_1
    const value_2 = quantities.value_2
    const values = getValues(value_1, value_2, answer, settings)
    const operation = settings.operation

    const axisScale = +settings.axis_scale || 1

    let axisValues = []


    const roundOption = settings.step_size
    const step = getStepSize(value_2, roundOption)
    const type = value_1 - step > value_1 - value_2 ? 'straight' : 'inverse'

    const axisStart = type === 'straight' ? value_1 - value_2 : value_1 - step
    const axisEnd = value_1
    const axisDivWidth = (gridBgWidth - axisSideMargin * 2 - axisLineWidth) / (axisEnd - axisStart)

    const answerRequired = settings.answer_required || 'answer'

    let maxArcHeight = gridBgHeight

    for (let i = 0; i <= (axisEnd - axisStart); i += axisScale) {
        axisValues.push(
            <g transform={`translate(${axisSideMargin + i * axisDivWidth}, ${gridBgHeight - 20})`}>
                <image
                    width={axisLineWidth}
                    height={axisLineHeight}
                    xlinkHref={images.svg['number-line-axis']}
                    
                />
                <text
                    fill="#fff"
                    fontSize={12}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={6}
                    y={axisLineHeight + 10}
                    textAnchor="middle"
                >{+axisStart + i}</text>
            </g>
        )
    }

    let arcStart = axisSideMargin + axisLineWidth / 2 + (value_1 - step - axisStart) * axisDivWidth
    let arcLength = ( step) * axisDivWidth
    let arcRadius = (arcLength) / 1.8
    let centerToChordLenght = Math.sqrt(Math.pow(arcRadius, 2) - Math.pow(arcLength / 2, 2))

    let arc2Start = axisSideMargin + axisLineWidth / 2 + (type === 'straight' ? value_1 - value_2 - axisStart :  value_1 - step - axisStart ) * axisDivWidth
    let arc2Length = (type === 'straight' ? value_2 - step : step - value_2) * axisDivWidth
    let arc2Radius = (arc2Length) / 1.8
    let centerToChordLenght2 = Math.sqrt(Math.pow(arc2Radius, 2) - Math.pow(arc2Length / 2, 2))

    maxArcHeight = arcRadius > arc2Radius ? arcRadius - centerToChordLenght + 40 : arc2Radius - centerToChordLenght2 + 40

    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}

        >
            <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale - (gridBgHeight - maxArcHeight)* scale) / 2}), scale(${scale})`}>
                {axisValues}
                <image
                    width={lineWidth}
                    height={lineHeight}
                    xlinkHref={images.svg['number-line']}
                    transform={`translate(${0}, ${gridBgHeight - 13})`}
                />
                <g>
                    <path
                        d={`M${arcStart} 185 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#000"
                        strokeOpacity="0.1"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    <path
                        d={`M${arcStart} 180 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#E30613"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />

                    {utils.getArrowLayout(arcStart, 185, 40, 4.01490021, "#E30613")}
                   
                    <g transform={`translate(${arcStart + arcLength / 2 - valueBgWidth / 2}, ${180 + centerToChordLenght - arcRadius - valueBgHeight * 1.2})`}>
                        <image
                            width={valueBgWidth}
                            height={valueBgHeight}
                            xlinkHref={images.svg['number-line-bg-red']}
                            
                        />
                        <text
                            fill="#fff"
                            fontSize={12}
                            fontWeight="regular"
                            dominantBaseline="middle"
                            x={valueBgWidth / 2}
                            y={15}
                            textAnchor="middle"
                        >{answerRequired === 'step_1' ? answer : '-' + step}</text>
                    </g>
                </g>

                {value_1 -step != value_1 - value_2 && <g>
                    <path
                        d={`M${arc2Start} 185 a ${arc2Radius} ${arc2Radius} 0 0 1 ${arc2Length} 0`}
                        stroke="#000"
                        strokeOpacity="0.1"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    <path
                        d={`M${arc2Start} 180 a ${arc2Radius} ${arc2Radius} 0 0 1 ${arc2Length} 0`}
                        stroke={type === 'inverse' ? "#95c11f" : "#E30613"}
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    {utils.getArrowLayout((type === 'inverse' ? arc2Start + arc2Length : arc2Start), 185, 40, 4.01490021, (type === 'inverse' ? "#95c11f" : "#E30613"))}
                    <g transform={`translate(${arc2Start + arc2Length / 2 - valueBgWidth / 2}, ${180 + centerToChordLenght2 - arc2Radius - (type === 'straight' || arc2Length < valueBgWidth ? valueBgHeight * 1.2 : -valueBgHeight * .2)})`}>
                        <image
                            width={valueBgWidth}
                            height={valueBgHeight}
                            xlinkHref={images.svg[`number-line-bg-${type === 'inverse' ? 'green' : 'red'}`]}
                            
                        />
                        <text
                            fill="#fff"
                            fontSize={12}
                            fontWeight="regular"
                            dominantBaseline="middle"
                            x={valueBgWidth / 2}
                            y={15}
                            textAnchor="middle"
                        >{(answerRequired === 'step_2' ? answer : (type === 'straight' ?  '-' + (value_2 - step) : '+' + (step - value_2)))}</text>
                    </g>
                </g>}
            </g>
        </svg>
    )
}

function getValues(value_1, value_2, answer, settings) {
    const operation = settings.operation
    const answerRequired = settings.answer_required || 'answer'
    const step = getStepSize(value_2, operation)

    if (operation === 'addition') {
        if (answerRequired === 'value_1') {
            return [answer, step - value_1, step, value_1 + value_2 - step, value_1 + value_2]
        } else if (answerRequired === 'step_1') {
            return [value_1, answer, step, value_1 + value_2 - step, value_1 + value_2]
        } else if (answerRequired === 'step_2') {
            return [value_1, step - value_1, step, answer, value_1 + value_2]
        } else if (answerRequired === 'bridge_point') {
            return [value_1, step - value_1, answer, value_1 + value_2 - step, value_1 + value_2]
        } else if (answerRequired === 'answer') {
            return [value_1, step - value_1, step, value_1 + value_2 - step, answer]
        } else {
            return [value_1, step - value_1, step, value_1 + value_2 - step, value_1 + value_2]
        }
    } else {
        if (answerRequired === 'value_1') {
            return [answer, step - value_1, step, value_1 - value_2 - step, value_1 - value_2]
        } else if (answerRequired === 'step_1') {
            return [value_1, answer, step, value_1 - value_2 - step, value_1 - value_2]
        } else if (answerRequired === 'step_2') {
            return [value_1, step - value_1, step, answer, value_1 + value_2]
        } else if (answerRequired === 'bridge_point') {
            return [value_1, step - value_1, answer, value_1 - value_2 - step, value_1 - value_2]
        } else if (answerRequired === 'answer') {
            return [value_1, step - value_1, step, value_1 - value_2 - step, answer]
        } else {
            return [value_1, step - value_1, step, value_1 - value_2 - step, value_1 - value_2]
        }
    }
}

function getStepSize(value, roundOption) {

    let step = 0

    if (roundOption === 'down') {
        step = Math.ceil(value / 10) * 10
    } else {
        step = Math.floor(value / 10) * 10
    }

    return step < 10 ? 10 : step
}

export default {
    getLevelLayout,
    getStepSize,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/numberBridge.utils.js